import { Route, Routes } from 'react-router-dom';
import AuthenticatePage from './Authenticate/AuthenticatePage';
import FeideSuccessPage from './FeideSuccessPage/FeideSuccessPage';
import EnterEmailPage from './OneTimePassword/EnterEmailPage';
import EnterOneTimePasswordPage from './OneTimePassword/EnterPasswordPage';
import EnterEmailSimplePage from './SimpleSignIn/EnterEmailPage';
import SimpleSignInPage from './SimpleSignIn/EnterPasswordPage';
import SupervisorInvitationAcceptPage from './SupervisorInvitationAccept/SupervisorInvitationAcceptPage';
import VippsSuccessPage from './VippsSuccessPage/VippsSuccessPage';
import IdPortenSuccessPage from './IdPortenSuccessPage/IdPortenSuccessPage';

const NotAuthenticatedRouter = () => (
  <Routes>
    <Route path="/feide-success" element={<FeideSuccessPage />} />
    <Route path="/vipps-success" element={<VippsSuccessPage />} />
    <Route path="/idporten-success" element={<IdPortenSuccessPage />} />
    <Route path="/login" element={<EnterEmailPage />} />
    <Route path="/login-simple" element={<EnterEmailSimplePage />} />
    <Route path="/otp" element={<EnterOneTimePasswordPage />} />
    <Route path="/otp-simple" element={<SimpleSignInPage />} />
    <Route
      path="/supervisor/accept-invitation"
      element={<SupervisorInvitationAcceptPage />}
    />
    <Route
      path="*"
      element={<AuthenticatePage data-testid="main-authenticate-page" />}
    />
  </Routes>
);
export default NotAuthenticatedRouter;
